import { render, staticRenderFns } from "./ProductSizes.vue?vue&type=template&id=38fd0de4"
import script from "./ProductSizes.vue?vue&type=script&lang=js"
export * from "./ProductSizes.vue?vue&type=script&lang=js"
import style0 from "./ProductSizes.vue?vue&type=style&index=0&id=38fd0de4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports